// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const buttonSide = "InsightFooter__buttonSide__yph-I";
export const left = "InsightFooter__left__S5NJQ";
export const right = "InsightFooter__right__-aOAG";
export const inverted = "InsightFooter__inverted__qSsfZ";
export const fullWidth = "InsightFooter__fullWidth__7r7U4";
export const minWidth = "InsightFooter__minWidth__-7wOZ";